import React, { useState } from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import logo from "../../../../../assets/images/site-logo/Logo.png";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import styles from "./ForgetModal.module.scss";
import MainButton from "../../../../shared/button/MainButton";
import { Link } from "react-router-dom";
import PhoneInputComponent from "../../../../shared/input-phone-component/PhoneInputComponent";
import {
  setIsForgetPassword,
  setIsLogin,
  setIsOtp,
  setOperationType,
  setOtpSession,
  setOtpType,
} from "../../../../../redux/Slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import CloseLeft from "../../../../../assets/images/pages/login/CaretLeft.svg";
import InputComponent from "../../../../shared/input/InputComponent";
import { resetPassword } from "../../../../../services/auth.service";
import { toast } from "react-toastify";
import { RootState } from "../../../../../redux/store";

const ForgetModal = () => {
  const dispatch = useDispatch();
  const [isModal, setIsModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);
  const [formValues, setFormValues] = useState({
    phone: "",
    email: "",
    prefix: "50",
  });
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const handleCodeChange = (code: string) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      prefix: code,
    }));
  };


  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const LoginClose = () => {
    dispatch(setIsForgetPassword(false));
    dispatch(setIsLogin(true));
  };

  const isPhoneValid = () => {
    return formValues.phone && formValues.phone.replace(/\D/g, "").length > 2;
  };

  const handleResetPassword = async () => {
    setIsSubmitting(true);

    try {
      const payload = {
        email: formValues.email,
        phone: formValues.phone,
      };
      const response = await resetPassword(payload);
      const type = isPhoneValid() ? "sms" : formValues.email ? "mail" : "";

      if (response.status === 200) {
        toast.success(data?.auth_common_otp_sent);
        dispatch(setOtpType(type));
        dispatch(setIsOtp(true));
        dispatch(setOtpSession(response?.data?.otp_session));
        dispatch(setOperationType("forgetPassword"));
      }
    } catch (error: any) {
      setFormErrors(error.response?.data || {});
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <GlobalModalComponent isOpen={true} onClose={() => setIsModal(!isModal)}>
      <div className={styles.loginModal}>
        <div className={styles.headerLogin}>
          <div className={styles.headerLeft} onClick={LoginClose}>
            <img className={styles.backLoginIcon} src={CloseLeft} alt="left" />
            <p className={styles.backLoginText}>{data?.auth_referal_login}</p>
          </div>
          <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
            <img
              className={styles.closeIcon}
              src={CloseIcon}
              alt="Close Icon"
              onClick={LoginClose}
            />
          </Link>
        </div>
        <div className={styles.modalContainer}>
          <div className={styles.logo}>
            <img src={logo} alt="colibri" />
          </div>
          <h3 className={styles.loginTitle}>
            {data?.auth_common_password_reset}
          </h3>
          <div className={styles.inputContainer}>
            <InputComponent
              label={data?.auth_referal_email}
              type="text"
              name="email"
              placeholder={data?.auth_referal_email}
              isPassword={false}
              value={formValues.email}
              onChange={handleInputChange}
              error={formErrors.email}
              disabled={!!isPhoneValid()}
            />
            <p>{data?.auth_common_or}</p>
            <PhoneInputComponent
              label={data?.auth_attorney_mobile}
              id="phone"
              name="phone"
              placeholder="0000000"
              value={""}
              onChange={handleInputChange}
              onCodeChange={handleCodeChange}
              error={formErrors.phone}
              disabled={!!formValues.email}
              combinePrefixWithNumber={true}
            />
            {formErrors.content && (
              <p className={styles.errorText}>{formErrors.content}</p>
            )}
            <MainButton
              text={data?.auth_referal_login}
              type="button"
              className={styles.buttonLogin}
              onClick={handleResetPassword}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default ForgetModal;
